var map = {
	"./EF-SET-Certificate-Yasmin-Molina.pdf": 6746,
	"./certificado-IBM-CAD220EN-edX.pdf": 6171,
	"./certificado-edx.pdf": 9474,
	"./certificado-javacrip-Basico.pdf": 2410,
	"./diploma-conceptos-programacion.pdf": 229,
	"./diplomas_Git.pdf": 8258,
	"./diplomas_Introduccion_a_Programacion.pdf": 3395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1847;